export const CARD_TYPES = Object.freeze({
  featured: "course-near-me",
  bestInCountry: "best-courses",
  ad: "banner",
  todayBestDeals: "deals-near-me",
  playNine: "play-nine",
  drivingRange: "driving-course-near-me",
  puttingGreen: "green-course-near-me",
  teachingPro: "pro-course-near-me",
  pitchingArea: "pitching-course-near-me",
  latestArticlesAndTips: "blogs",
  exploreGame: "explore-game",
  exploreByCountries: "explore-countries",
  travelingDestinations: "destinations",
  latestReview: "latest-reviews",
});

export const ZEST_API_RESPONSE_TYPES = Object.freeze({
  pending: "pending",
  fulfilled: "fulfilled",
  rejected: "rejected",
});

export const ZEST_API_REQUEST_INTERVAL = 3000;
export const DEFAULT_SEARCH_COUNTRY = "Spain";
export const TEE_TIME_MAX_PRICE = 120;
export const TEE_TIME_PRICE_STEP = 1;
export const PLAYERS = [1, 2, 3, 4];
export const HOLES = [9, 18];

export const RECENT_DATA_COUNT = 3;
